import React from 'react'

import styled from 'styled-components'

import HeaderCell from 'components/Table/HeaderCell'

import { color } from 'styles/colors'
import { NoData, screenSize } from 'styles/shared'

type noDataMessage = {
  title: string;
  description: string| null;
}

interface Table {
  noDataMessage?: noDataMessage;
  items?: Array<object | string>;
  children?: React.ReactNode;
  className?: string;
}

const Table = ({ noDataMessage, items = [], children = null, className = '' }: Table) => {
  return (
    <>
      {(items?.length ?? 0) === 0 && noDataMessage
        ? (
          <NoData>
            <h1>{noDataMessage.title}</h1>
            {noDataMessage.description && <h2>{noDataMessage.description}</h2>}
          </NoData>
        )
        : (
          <div className={className}>
            {children}
          </div>
        )
      }
    </>
  )
}

Table.Header = styled.div.withConfig({
  shouldForwardProp: (prop) => !['sticky'].includes(prop)
})<{ sticky?: boolean }>`
  display: flex;
  flex-direction: row;

  ${({ sticky }) => sticky && `
    position: sticky;
    top: 0;
    z-index: 99;
  `}

  @media ${screenSize.small} {
    display: none;
  }
`
Table.HeaderCell = HeaderCell
Table.Row = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid ${color('divider')};

  @media ${screenSize.small} {
    flex-direction: column;
    padding-bottom: 15px;
    padding-top: 15px;
  }
`
Table.Cell = styled.div`
  display: flex;
  flex: 1;

  @media ${screenSize.small} {
    line-height: 1.5;
  }
`

export default Table
